import { render, staticRenderFns } from "./RolSelectChip.vue?vue&type=template&id=4b13684a&"
import script from "./RolSelectChip.vue?vue&type=script&lang=js&"
export * from "./RolSelectChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports